var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"c-epilogue-card pa-2",attrs:{"elevation":"4"}},[_c('v-card-title',{staticClass:"font-italic text-h5 py-2"},[_vm._v(" "+_vm._s(_vm.$t('quiz.epilogue'))+" ")]),_c('v-card-text',{staticClass:"c-epilogue-text"},[_c('RichText',{attrs:{"blocks":_vm.quiz.epilogue}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }